import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from './ThemeContext';
import './ThemeSwitch.scss';

const ThemeSwitch = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className={`arc-theme-switch ${className}`}
      onClick={toggleTheme}
      title={theme === 'dark' ? 'Açık moda geç' : 'Koyu moda geç'}
      aria-label="Toggle theme"
    >
      <div className={`arc-theme-icon-wrap ${theme}`}>
        {theme === 'dark' ? (
          <Moon className="arc-theme-icon moon" size={16} />
        ) : (
          <Sun className="arc-theme-icon sun" size={16} />
        )}
      </div>
    </button>
  );
};

export default ThemeSwitch;
